export enum DashboardTypes {
  PREFERENCES_REQUEST = '@dashboard/PREFERENCES_REQUEST',
  PREFERENCES_SUCCCESS = '@dashboard/PREFERENCES_SUCCCESS',
  PREFERENCES_FAILURE = '@dashboard/PREFERENCES_FAILURE',
  PREFERENCES_CHANGE_GOAL = '@dashboard/PREFERENCES_CHANGE_GOAL',
  PREFERENCES_SHOW_INFORMATION = '@dashboard/PREFERENCES_SHOW_INFORMATION',
}

export interface ICourse {
  _id: string
  name: string
  hoursGoal: number
}

export interface IStudyGoal {
  _id?: string
  createdAt?: string

  courses: { [courseId: string]: ICourse }

  student?: {
    name: string
    _id: string
  }
}

export interface IShowTooltip {
  showTooltipPerformance: boolean
}

export interface DashboardState {
  readonly preferences: {
    readonly data: IStudyGoal
    readonly loading: boolean
    readonly error: boolean
    readonly fetched: boolean
    readonly showInformationTooltip: boolean
  }
}
